const GET_COMPANY = `SELECT * FROM inno.companies WHERE company_id = $1;`;

const CREATE_COMPANY = `INSERT INTO inno.companies (
        company_name,
        company_fullname,
        company_email,
        website,
        logo,
        company_phone,
        adress,
        province,
        district,
        country,
        description,
        sector_id,
        currency_id,
        vision,
        mission,
        values,
        total_employee_number,
        sust_email,
        sust_website,
        organization_chart,
        facility_number,
        promo_code_id,
        add_country_id,
        add_state_id,
        add_province_id,
        created_by,
        created_on,
        is_deleted
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        $5,
        $6,
        $7,
        $8,
        $9,
        $10,
        $11,
        $12,
        $13,
        $14,
        $15,
        $16,
        $17,
        $18,
        $19,
        $20,
        $21,
        $22,
        $23,
        $24,
        $25,
        $26,
        CURRENT_TIMESTAMP,
        false
    ) RETURNING company_id;
`;

const GET_FACILITIES = `SELECT * FROM inno.facilities WHERE company_id = $1 AND is_deleted = false ORDER BY facility_id;`;

const CREATE_FACILITY = `INSERT INTO inno.facilities (
        company_id,
        facility_name,
        description,
        email,
        phone,
        address,
        province,
        district,
        country,
        created_by,
        created_on,
        is_deleted
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        $5,
        $6,
        $7,
        $8,
        $9,
        $10,
        CURRENT_TIMESTAMP,
        false
    ) RETURNING facility_id;
`;

const GET_MILESTONES = `SELECT * FROM inno.milestones WHERE company_id = $1 AND is_deleted = false ORDER BY milestone_id;`;

const CREATE_MILESTONE = `INSERT INTO inno.milestones (
        company_id,
        milestone_year,
        milestone_text,
        created_by,
        created_on
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        CURRENT_TIMESTAMP
    ) RETURNING milestone_id;
`;

const GET_AWARDS = `SELECT * FROM inno.awards WHERE company_id = $1 AND is_deleted = false ORDER BY award_id;`;

const CREATE_AWARD = `INSERT INTO inno.awards (
        company_id,
        award_year,
        award_name,
        created_by,
        created_on
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        CURRENT_TIMESTAMP
    ) RETURNING award_id;
`;

const GET_COMPANY_MEMBERSHIPS = `SELECT * FROM inno.company_memberships WHERE company_id = $1 AND is_deleted = false ORDER BY company_membership_id;`;

const CREATE_COMPANY_MEMBERSHIP = `INSERT INTO inno.company_memberships (
        company_id,
        company_membership_date,
        company_membership_name,
        created_by,
        created_on
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        CURRENT_TIMESTAMP
    ) RETURNING company_membership_id;
`;

const GET_COMPANY_DEVELOPMENT_NETWORKS = `SELECT * FROM inno.company_development_networks WHERE company_id = $1 AND is_deleted = false ORDER BY company_development_network_id;`;

const CREATE_COMPANY_DEVELOPMENT_NETWORK = `INSERT INTO inno.company_development_networks (
        company_id,
        company_development_network_membership_date,
        company_development_network_name,
        created_by,
        created_on
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        CURRENT_TIMESTAMP
    ) RETURNING company_development_network_id;
`;

const GET_PRODUCT_GROUPS = `SELECT * FROM inno.product_groups WHERE company_id = $1 AND is_deleted = false ORDER BY product_group_id;`;

const CREATE_PRODUCT_GROUP = `INSERT INTO inno.product_groups (
        company_id,
        product_group_name,
        product_group_name_tr,
        production_year,
        production_percent,
        production_count,
        production_tonnes,
        production_revenue_share,
        created_by,
        created_on
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        $5,
        $6,
        $7,
        $8,
        $9,
        CURRENT_TIMESTAMP
    ) RETURNING product_group_id;
`;

const GET_REPORT_PUBLISHING_STATUS = `SELECT * FROM inno.company_report_publishing_status WHERE company_id = $1;`;

const CREATE_REPORT_PUBLISHING_STATUS = `INSERT INTO inno.company_report_publishing_status (
        company_id,
        reports_published,
        report_languages_selected
    ) VALUES (
        $1,
        $2,
        $3
    ) RETURNING company_report_publishing_status_id;
`;

const GET_CARBON_OPTIONS = `SELECT * FROM inno.carbon_options WHERE company_id = $1;`;

const CREATE_CARBON_OPTIONS = `INSERT INTO inno.carbon_options (
        company_id,
        base_year_selection,
        base_year,
        calculation_type,
        manual_iso_values,
        manual_defra_values,
        activity_sector,
        target_audience,
        reporting_frequency,
        head_department_for_reporting,
        head_department_for_auditing,
        auditing_method,
        included_facilities,
        entities_out_of_bound,
        has_removal_process,
        removal_process,
        revenue,
        calculation_method,
        reason_for_method_change,
        exclusion_criteria,
        designated_confidence_level,
        emission_density_calculation,
        emission_density_unit,
        emission_density_value,
        materiality_threshold,
        require_internal_audit
    ) VALUES (
        $1, $2, $3, $4, $5, $6, $7, $8, $9,
        $10, $11, $12, $13, $14, $15, $16, $17, $18, $19, 
        $20, $21, $22, $23, $24, $25, $26
    ) RETURNING id;
`;

const UPDATE_LOGO_AND_ORG_CHART = `UPDATE inno.companies 
    SET logo = $2, organization_chart = $3
    WHERE company_id = $1
    RETURNING company_id;
`;

const GET_LICENCE = `SELECT * FROM inno.company_licences WHERE company_id = $1;`;

const CREATE_LICENCE = `INSERT INTO inno.company_licences (
        company_id,
        plan_id,
        licence_start_date,
        licence_end_date,
        licence_status,
        optional_module_1_id,
        optional_module_2_id,
        optional_module_3_id,
        optional_module_4_id,
        created_by,
        created_on,
        is_deleted
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        $5,
        $6,
        $7,
        $8,
        $9,
        $10,
        CURRENT_TIMESTAMP,
        false
    ) RETURNING company_licence_id;
`;

const GET_COMPANY_CODE = `SELECT * FROM inno.company_codes WHERE company_id = $1;`;

const CREATE_COMPANY_CODE = `INSERT INTO inno.company_codes (
        company_id,
        executive_code,
        white_label_code,
        regular_company_code,
        supplier_code,
        created_by,
        created_on,
        is_deleted
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        $5,
        $6,
        CURRENT_TIMESTAMP,
        false
    ) RETURNING company_code_id;
`;

const GET_BIGGEST_REGULAR_COMPANY_CODE = `SELECT regular_company_code FROM inno.company_codes
    WHERE executive_code = $1
    AND white_label_code = $2
    ORDER BY regular_company_code DESC
    LIMIT 1;
`;

const GET_BIGGEST_SUPPLIER_COMPANY_CODE = `SELECT supplier_code FROM inno.company_codes
    WHERE executive_code = $1
    AND white_label_code = $2
    AND regular_company_code = $3
    ORDER BY supplier_code DESC
    LIMIT 1;
`;

const GET_USER = `SELECT * FROM inno.users WHERE user_id = $1;`;

const CREATE_USER = `INSERT INTO inno.users (
        role_id,
        username,
        userpwd,
        firstname,
        surname,
        email,
        phone,
        company_id,
        is_active,
        email_token,
        activated_on,
        user_licence_id,
        user_department_id,
        plan_id,
        user_language,
        created_by,
        created_on,
        is_deleted
    ) VALUES (
        $1,
        $2,
        $3,
        $4,
        $5,
        $6,
        $7,
        $8,
        $9,
        $10,
        $11,
        $12,
        $13,
        $14,
        $15,
        $16,
        CURRENT_TIMESTAMP,
        false
    ) RETURNING *;
`;

const GET_PROCESS_TRACK = `SELECT * FROM inno.reporting_process_tracks WHERE company_id = $1;`;

const CREATE_PROCESS_TRACK = `INSERT INTO inno.reporting_process_tracks (
        company_id,
        is_step_1_completed,
        is_step_2_completed,
        is_step_3_completed,
        is_step_4_completed,
        is_step_5_completed,
        is_step_6_completed,
        is_step_7_completed,
        is_step_8_completed,
        is_step_9_completed,
        is_step_10_completed,
        is_step_11_completed,
        is_step_12_completed,
        is_step_13_completed,
        is_step_14_completed,
        description,
        year,
        user_id,
        created_on, is_deleted
    ) VALUES (
        $1, $2, $3,
        $4, $5, $6,
        $7, $8, $9,
        $10, $11, $12,
        $13, $14, $15,
        $16, $17, $18,
        CURRENT_TIMESTAMP, false
    ) RETURNING reporting_process_track_id;
`;

/*** @typedef {'su1' | 'su2'} SurveyType */

/**
 * Builds and returns a survey fetch query for the given type of survey
 * @param {SurveyType} type 
 */
function GET_SURVEY(type) {
    return `SELECT 
        ${type}_survey_id,
        * 
    FROM inno.${type}_surveys 
    WHERE company_id = $1 AND is_deleted = false;`;
}

/**
 * Builds and returns a survey insert query for the given type of survey
 * @param {SurveyType} type 
 */
function INSERT_SURVEY(type) {
    return `INSERT INTO inno.${type}_surveys (
        ${type}_survey_name, ${type}_s_description,
        company_id, survey_token,
        is_send, sending_date,
        is_completed, completed_on,
        reminder_frequency_day, end_date,
        created_by, created_on
    ) VALUES (
        $1, $2,
        $3, $4,
        $5, $6,
        $7, $8,
        $9, $10,
        $11, CURRENT_TIMESTAMP
    ) RETURNING ${type}_survey_id;`;
}

/**
 * Builds and returns a survey_infos fetch query for the given type of survey
 * @param {SurveyType} type 
 */
function GET_SURVEY_INFOS(type) {
    return `SELECT 
        * 
    FROM inno.${type}_survey_infos 
    WHERE ${type}_survey_id = $1;`;
}

/**
 * Builds and returns a survey_infos insert query for the given type of survey
 * @param {SurveyType} type 
 */
function INSERT_SURVEY_INFOS(type) {
    return `INSERT INTO inno.${type}_survey_infos (
        ${type}_survey_id, user_id,
        sent_date, resolved_date,
        is_sent, is_resolved
    ) VALUES (
        $1, $2,
        $3, $4,
        $5, $6
    ) RETURNING ${type}_survey_id;`;
}

/**
 * Builds and returns a survey_participation fetch query for the given type of survey
 * @param {SurveyType} type 
 */
function GET_SURVEY_PARTICIPATION(type) {
    return `SELECT 
        * 
    FROM inno.${type}_survey_participation 
    WHERE ${type}_survey_id = $1;`;
}

/**
 * Builds and returns a survey_participation insert query for the given type of survey
 * @param {SurveyType} type 
 */
function INSERT_SURVEY_PARTICIPATION(type) {
    return `INSERT INTO inno.${type}_survey_participation (
        ${type}_survey_id,
        user_id,
        receive_survey_link,
        survey_link,
        created_by,
        created_on
    ) VALUES (
        $1, $2, $3, $4, $5, CURRENT_TIMESTAMP
    ) RETURNING ${type}_survey_id;`;
}

/**
 * Builds and returns a SU1 results fetch query for the given results table
 * @param { 'su1_texts_results' | 'su1_green_deals_results' | 'su1_global_goals_results' | 'su1_sub_goals_results' } table 
 */
function GET_SU1_RESULTS(table) {
    return `SELECT 
        * 
    FROM inno.${table}
    WHERE su1_survey_id = $1;`;
}

const INSERT_GLOBAL_GOALS_RESULT = `INSERT INTO inno.su1_global_goals_results (
    su1_survey_id,
    company_id,
    completed_by,
    completed_on,
    su1_global_goals_answer
) VALUES (
    $1, $2, $3, $4, $5
) RETURNING su1_global_goals_result_id;`;

const INSERT_SUB_GOALS_RESULT = `INSERT INTO inno.su1_sub_goals_results (
    su1_survey_id,
    company_id,
    completed_by,
    completed_on,
    su1_sub_goals_answer
) VALUES (
    $1, $2, $3, $4, $5
) RETURNING su1_sub_goals_result_id;`;

const INSERT_GREEN_DEALS_RESULT = `INSERT INTO inno.su1_green_deals_results (
    su1_survey_id,
    company_id,
    completed_by,
    completed_on,
    su1_green_deals_answer
) VALUES (
    $1, $2, $3, $4, $5
) RETURNING su1_green_deals_result_id;`;

const INSERT_SU1_TEXTS_RESULT = `INSERT INTO inno.su1_texts_results (
    su1_survey_id,
    company_id,
    completed_by,
    completed_on,
    su1_texts_answer_1,
    su1_texts_answer_2,
    su1_texts_answer_1_en,
    su1_texts_answer_2_en
) VALUES (
    $1, $2, $3, $4, $5, $6, $7, $8
) RETURNING su1_texts_result_id;`;

const GET_SU2_SURVEY_QUESTIONS = `SELECT * FROM inno.su2_created_survey_questions
WHERE su2_survey_id = $1;`;

const INSERT_SU2_SURVEY_QUESTIONS = `INSERT INTO inno.su2_created_survey_questions (
    sust_element_category_id,
    sust_element_id,
    su2_survey_id,
    survey_token,
    created_by,
    created_on,
    is_deleted
) VALUES (
    $1,
    $2,
    $3,
    $4,
    $5,
    CURRENT_TIMESTAMP,
    false
) RETURNING su2_cs_id;`;

const GET_SU2_SURVEY_RESULTS = `SELECT * FROM inno.su2_results
WHERE su2_survey_id = $1;`;

const INSERT_SU2_SURVEY_RESULTS = `INSERT INTO inno.su2_results (
    su2_survey_id,
    su2_cs_id,
    company_id,
    completed_by,
    completed_on,
    su2_cs_answer,
    su2_text_answer,
    su2_text_answer_en
) VALUES (
    $1,
    $2,
    $3,
    $4,
    $5,
    $6,
    $7,
    $8
) RETURNING su2_result_id;`;

const GET_REPORTS = `SELECT * FROM inno.my_reports
WHERE company_id = $1 AND is_deleted = false AND report_status != 'failed';`;

const CREATE_REPORT = `INSERT INTO inno.my_reports (
    company_id,
    my_report_name,
    my_report_description,
    my_report_link,
    report_language,
    report_type,
    report_status,
    report_audit_status,
    auditor_comments,
    user_id,
    created_on
) VALUES (
    $1,
    $2,
    $3,
    $4,
    $5,
    $6,
    $7,
    $8,
    $9,
    $10,
    CURRENT_TIMESTAMP
) RETURNING my_report_id;`;

const GET_SUST_SECTIONS = `SELECT * FROM inno.sust_report_sections
WHERE company_id = $1 AND is_deleted = false;`;

const CREATE_SUST_SECTION = `INSERT INTO inno.sust_report_sections (
    company_id,
    sust_report_section_order,
    sust_report_section_name,
    seed_text,
    generated_text,
    generated_text_tr,
    is_selected,
    created_by,
    created_on
) VALUES (
    $1,
    $2,
    $3,
    $4,
    $5,
    $6,
    $7,
    $8,
    CURRENT_TIMESTAMP
) RETURNING sust_report_section_id;`;

const GET_ELEMENT_SECTIONS = `SELECT * FROM inno.element_sections
WHERE company_id = $1 AND is_deleted = false;`;

const CREATE_ELEMENT_SECTION = `INSERT INTO inno.element_sections (
    company_id,
    sust_element_id,
    seed_text,
    generated_text,
    generated_text_tr,
    generated_header,
    generated_header_tr,
    is_selected,
    created_by,
    created_on
) VALUES (
    $1,
    $2,
    $3,
    $4,
    $5,
    $6,
    $7,
    $8,
    $9,
    CURRENT_TIMESTAMP
) RETURNING element_section_id;`;

const GET_METRICS = `SELECT * FROM inno.metrics_input_table
WHERE company_id = $1 AND is_deleted = false`;

const CREATE_METRIC = `INSERT INTO inno.metrics_input_table (
    company_id,
    facility_id,
    metric_kpi_id,
    sub_metric_kpi_id,
    value,
    year,
    quarter,
    created_by,
    created_on
) VALUES (
    $1,
    $2,
    $3,
    $4,
    $5,
    $6,
    $7,
    $8,
    CURRENT_TIMESTAMP
) RETURNING metrics_input_table_id;`;

const GET_TOTAL_METRICS = `SELECT * FROM inno.total_metrics_inputs
WHERE company_id = $1 AND is_deleted = false`;

const CREATE_TOTAL_METRIC = `INSERT INTO inno.total_metrics_inputs (
    company_id,
    metric_kpi_id,
    sub_metric_kpi_id,
    value,
    year,
    quarter,
    created_by,
    created_on
) VALUES (
    $1,
    $2,
    $3,
    $4,
    $5,
    $6,
    $7,
    CURRENT_TIMESTAMP
) RETURNING total_metrics_input_id`;

const GET_CARBON_INPUTS = `SELECT * FROM iso_carbon.emission_inputs
WHERE company_id = $1 AND is_deleted = false;`;

const CREATE_EMISSION_INPUT = `INSERT INTO iso_carbon.emission_inputs (
    sub_category_number,
    name,
    description,
    emission_factor_name,
    mobility_type_id,
    sector_id,
    combustion_factor_id,
    defra_factor_id,
    refrigerant_factor_id,
    gwp_factor_id,
    wtt_factor_id,
    maintenance_load,
    maintenance_date,
    country_id,
    power_line_id,
    trip_id,
    trip_type,
    hotel_stay_factor_id,
    electric_factor_id,
    defra_vehicle_factor_id,
    epa_factor_id,
    unit,
    amount,
    sustainable_electricity_percentage,
    density,
    oxidation_factor,
    year,
    quarter,
    company_id,
    facility_id,
    emission_group_id,
    created_by,
    created_on
) VALUES (
    $1, $2, $3,
    $4, $5, $6,
    $7, $8, $9,
    $10, $11, $12,
    $13, $14, $15,
    $16, $17, $18,
    $19, $20, $21,
    $22, $23, $24,
    $25, $26, $27,
    $28, $29, $30,
    $31, $32, CURRENT_TIMESTAMP
) RETURNING id;`;

const GET_EMISSION_FACTOR = `SELECT * FROM iso_carbon.emission_factors
WHERE input_id = $1;`;

const CREATE_EMISSION_FACTOR = `INSERT INTO iso_carbon.emission_factors (
    input_id,
    ncv_default,
    co2_default,
    ch4_default,
    n2o_default,
    emission_factor_operation_lower,
    emission_factor_initial_lower,
    kgco2e,
    kgco2e_wtt,
    kgco2e_of_co2_per_unit,
    kgco2e_of_ch4_per_unit,
    kgco2e_of_n2o_per_unit,
    production,
    td_loss_percentage,
    hotel_stay_factor_value,
    epa_margin,
    epa_without_margin,
    epa_with_margin,
    custom_data,
    composition
) VALUES (
    $1, $2, $3,
    $4, $5, $6,
    $7, $8, $9,
    $10, $11, $12,
    $13, $14, $15,
    $16, $17, $18,
    $19, $20
) RETURNING id;`;

const GET_EMISSION_OUTPUT = `SELECT * FROM iso_carbon.emission_outputs
WHERE input_id = $1;`;

const CREATE_EMISSION_OUTPUT = `INSERT INTO iso_carbon.emission_outputs (
    input_id,
    co2,
    ch4,
    n2o,
    co2e,
    unsustainable_co2e,
    co2e_ch4,
    co2e_n2o,
    leakage_co2e,
    stray_co2e,
    wtt_co2e,
    margin_co2e,
    without_margin_co2e,
    custom_data,
    hfc,
    pfc,
    sf6,
    nf3
) VALUES (
    $1, $2, $3,
    $4, $5, $6,
    $7, $8, $9,
    $10, $11, $12,
    $13, $14, $15,
    $16, $17, $18
) RETURNING id;`;

const GET_EMISSION_GHOST_OUTPUT = `SELECT * FROM iso_carbon.emission_ghost_outputs
WHERE input_id = $1;`;

const CREATE_EMISSION_GHOST_OUTPUT = `INSERT INTO iso_carbon.emission_ghost_outputs (
    input_id,
    category_number,
    sub_category_number,
    co2e,
    unsustainable_co2e
) VALUES (
    $1, $2, $3,
    $4, $5
) RETURNING id;`;

const GET_EMISSION_INPUT_GROUPS = `SELECT * FROM iso_carbon.emission_input_groups G
INNER JOIN inno.users U ON G.created_by = U.user_id
WHERE U.company_id = $1 AND G.is_deleted = false;`;

const CREATE_EMISSION_INPUT_GROUP = `INSERT INTO iso_carbon.emission_input_groups (
    name,
    description,
    sub_category_number,
    created_by
) VALUES (
    $1, $2, $3, $4
) RETURNING id;`;

const GET_DOCUMENTS = `SELECT * FROM documents.main
WHERE company_id = $1 AND is_deleted = false;`;

const CREATE_DOCUMENT = `INSERT INTO documents.main (
    hash,
    name,
    path,
    old_path,
    company_id,
    facility_id,
    created_by,
    created_on
) VALUES (
    $1, $2, $3,
    $4, $5, $6,
    $7, CURRENT_TIMESTAMP
) RETURNING id;`;

const GET_DOCUMENT_RELATIONS = `SELECT * FROM documents.relation
WHERE document_id = $1;`;

const CREATE_DOCUMENT_RELATION = `INSERT INTO documents.relation (
    document_id,
    carbon_category_1_inputs,
    carbon_category_2_inputs,
    carbon_category_3_inputs,
    carbon_category_4_inputs,
    carbon_category_5_inputs,
    carbon_category_6_inputs,
    metric_inputs,
    sub_metric_inputs
) VALUES (
    $1, $2, $3,
    $4, $5, $6,
    $7, $8, $9
) RETURNING id;`;

// fetches the vital details of a company including its company_name, company_fullname, company_email and users (firstname, lastname, email)
const GET_COMPANY_DETAILS = `SELECT 
    c.company_id, 
    c.company_name as name, 
    c.company_fullname as fullname, 
    c.company_email as email,
    c.company_phone as phone,
    json_agg(DISTINCT jsonb_build_object(
        'id', u.user_id,
        'name', u.firstname,
        'surname', u.surname,
        'email', u.email
    )) FILTER (WHERE u.user_id IS NOT NULL) AS users
FROM inno.companies c
LEFT JOIN inno.users u ON c.company_id = u.company_id AND u.is_deleted = false
WHERE c.company_id = $1 AND c.is_deleted = false
GROUP BY c.company_id;`;

module.exports = {
    GET_COMPANY,
    CREATE_COMPANY,
    GET_FACILITIES,
    CREATE_FACILITY,
    GET_MILESTONES,
    CREATE_MILESTONE,
    GET_AWARDS,
    CREATE_AWARD,
    GET_COMPANY_MEMBERSHIPS,
    CREATE_COMPANY_MEMBERSHIP,
    GET_COMPANY_DEVELOPMENT_NETWORKS,
    CREATE_COMPANY_DEVELOPMENT_NETWORK,
    GET_PRODUCT_GROUPS,
    CREATE_PRODUCT_GROUP,
    GET_REPORT_PUBLISHING_STATUS,
    CREATE_REPORT_PUBLISHING_STATUS,
    GET_CARBON_OPTIONS,
    CREATE_CARBON_OPTIONS,
    UPDATE_LOGO_AND_ORG_CHART,
    GET_LICENCE,
    CREATE_LICENCE,
    GET_COMPANY_CODE,
    CREATE_COMPANY_CODE,
    GET_BIGGEST_REGULAR_COMPANY_CODE,
    GET_BIGGEST_SUPPLIER_COMPANY_CODE,
    GET_USER,
    CREATE_USER,
    GET_PROCESS_TRACK,
    CREATE_PROCESS_TRACK,
    GET_SURVEY,
    INSERT_SURVEY,
    GET_SURVEY_INFOS,
    INSERT_SURVEY_INFOS,
    GET_SURVEY_PARTICIPATION,
    INSERT_SURVEY_PARTICIPATION,
    GET_SU1_RESULTS,
    INSERT_GLOBAL_GOALS_RESULT,
    INSERT_SUB_GOALS_RESULT,
    INSERT_GREEN_DEALS_RESULT,
    INSERT_SU1_TEXTS_RESULT,
    GET_SU2_SURVEY_QUESTIONS,
    INSERT_SU2_SURVEY_QUESTIONS,
    GET_SU2_SURVEY_RESULTS,
    INSERT_SU2_SURVEY_RESULTS,
    GET_REPORTS,
    CREATE_REPORT,
    GET_SUST_SECTIONS,
    CREATE_SUST_SECTION,
    GET_ELEMENT_SECTIONS,
    CREATE_ELEMENT_SECTION,
    GET_METRICS,
    CREATE_METRIC,
    GET_TOTAL_METRICS,
    CREATE_TOTAL_METRIC,

    GET_CARBON_INPUTS,
    CREATE_EMISSION_INPUT,
    GET_EMISSION_FACTOR,
    CREATE_EMISSION_FACTOR,
    GET_EMISSION_OUTPUT,
    CREATE_EMISSION_OUTPUT,
    GET_EMISSION_GHOST_OUTPUT,
    CREATE_EMISSION_GHOST_OUTPUT,
    GET_EMISSION_INPUT_GROUPS,
    CREATE_EMISSION_INPUT_GROUP,

    GET_DOCUMENTS,
    CREATE_DOCUMENT,
    GET_DOCUMENT_RELATIONS,
    CREATE_DOCUMENT_RELATION,

    GET_COMPANY_DETAILS,
};